export default __webpack_public_path__ + "static/media/launchpadlogo.965e01d3.jpeg";